/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaschinenAuslastungKumuliert
 */
export interface MaschinenAuslastungKumuliert {
    /**
     * ID-Name der Maschinengruppe
     * @type {string}
     * @memberof MaschinenAuslastungKumuliert
     */
    maschinenGruppe: string;
    /**
     * 
     * @type {string}
     * @memberof MaschinenAuslastungKumuliert
     */
    prognoseGruppeName: string;
    /**
     * 
     * @type {string}
     * @memberof MaschinenAuslastungKumuliert
     */
    prognoseStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof MaschinenAuslastungKumuliert
     */
    monat: number;
    /**
     * 
     * @type {string}
     * @memberof MaschinenAuslastungKumuliert
     */
    quelle: MaschinenAuslastungKumuliertQuelleEnum;
    /**
     * Anzahl der Schichten (ohne stornierte)
     * @type {number}
     * @memberof MaschinenAuslastungKumuliert
     */
    anzahlSchichten: number;
    /**
     * Anzahl stornierter Schichten
     * @type {number}
     * @memberof MaschinenAuslastungKumuliert
     */
    anzahlSchichtenStorniert: number;
    /**
     * Anzahl der manuell überschriebenen Schichten, falls vorhanden
     * @type {number}
     * @memberof MaschinenAuslastungKumuliert
     */
    anzahlUeberschrieben: number;
}


/**
 * @export
 */
export const MaschinenAuslastungKumuliertQuelleEnum = {
    Soll: 'SOLL',
    Ist: 'IST'
} as const;
export type MaschinenAuslastungKumuliertQuelleEnum = typeof MaschinenAuslastungKumuliertQuelleEnum[keyof typeof MaschinenAuslastungKumuliertQuelleEnum];


/**
 * Check if a given object implements the MaschinenAuslastungKumuliert interface.
 */
export function instanceOfMaschinenAuslastungKumuliert(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "maschinenGruppe" in value;
    isInstance = isInstance && "prognoseGruppeName" in value;
    isInstance = isInstance && "monat" in value;
    isInstance = isInstance && "quelle" in value;
    isInstance = isInstance && "anzahlSchichten" in value;
    isInstance = isInstance && "anzahlSchichtenStorniert" in value;
    isInstance = isInstance && "anzahlUeberschrieben" in value;

    return isInstance;
}

export function MaschinenAuslastungKumuliertFromJSON(json: any): MaschinenAuslastungKumuliert {
    return MaschinenAuslastungKumuliertFromJSONTyped(json, false);
}

export function MaschinenAuslastungKumuliertFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaschinenAuslastungKumuliert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maschinenGruppe': json['maschinenGruppe'],
        'prognoseGruppeName': json['prognoseGruppeName'],
        'prognoseStatus': !exists(json, 'prognoseStatus') ? undefined : json['prognoseStatus'],
        'monat': json['monat'],
        'quelle': json['quelle'],
        'anzahlSchichten': json['anzahlSchichten'],
        'anzahlSchichtenStorniert': json['anzahlSchichtenStorniert'],
        'anzahlUeberschrieben': json['anzahlUeberschrieben'],
    };
}

export function MaschinenAuslastungKumuliertToJSON(value?: MaschinenAuslastungKumuliert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maschinenGruppe': value.maschinenGruppe,
        'prognoseGruppeName': value.prognoseGruppeName,
        'prognoseStatus': value.prognoseStatus,
        'monat': value.monat,
        'quelle': value.quelle,
        'anzahlSchichten': value.anzahlSchichten,
        'anzahlSchichtenStorniert': value.anzahlSchichtenStorniert,
        'anzahlUeberschrieben': value.anzahlUeberschrieben,
    };
}

